import React, { createContext, useState, useContext, useEffect } from 'react';
import { api } from '../utils/Api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Verificar si hay un token guardado
    const token = localStorage.getItem('token');
    if (token) {
      // Aquí podrías verificar el token con el backend
      const userData = JSON.parse(localStorage.getItem('user') || 'null');
      
      if (userData) {
        setUser(userData);
      }
    }
    setLoading(false);
  }, []);

  // const login = async (googleData) => {
  //   try {
  //     setLoading(true);
  //     setError(null);
      
  //     const response = await api.post('/auth/google', {
  //       credential: googleData.credential
  //     });

  //     if (response.data) {
  //         // Soporta ambos formatos: { success: true, data: { user } } 
  // // o { user, token } directamente
  // const userData = response.data.data?.user || response.data.user;
  // const token = response.data.data?.token || response.data.token;
  // const isNewUser = response.data.data.isNewUser;
  
  // if (userData && token) {
  //   setUser(userData);
  //   localStorage.setItem('token', token);
  //   localStorage.setItem('user', JSON.stringify(userData));
  //   return { success: true, isNewUser: isNewUser || false };
  // }
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.error || 'Error al iniciar sesión');
  //     return { success: false, error: err.response?.data?.error };
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const login = async (googleData) => {
  try {
    setLoading(true);
    setError(null);
    
    const response = await api.post('/auth/google', {
      credential: googleData.credential
    });

    

    if (response.data) {
      const userData = response.data.data?.user || response.data.user;
      const token = response.data.data?.token || response.data.token;
      const isNewUser = response.data.data?.isNewUser || false; // ← Asegurar que existe
      
      
      
      if (userData && token) {
        setUser(userData);
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        
        // Devolver isNewUser y el user actualizado en el resultado
        return {
          success: true,
          isNewUser: isNewUser,
          user: userData
        };
      }
    }
  } catch (err) {
    setError(err.response?.data?.error || 'Error al iniciar sesión');
    return { success: false, error: err.response?.data?.error };
  } finally {
    setLoading(false);
  }
};


const logout = async () => {
  console.log(' AuthContext: Iniciando logout');
  
  // 1. Primero limpiamos el estado LOCAL (inmediato)
  setUser(null);
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // 2. Luego intentamos notificar al backend (opcional, no bloqueante)
  try {
    await api.post('/auth/logout');
    console.log('📍 AuthContext: Backend notificado');
  } catch (error) {
    // Si falla, no importa, ya limpiamos local
    console.log('AuthContext: Error notificando backend (ignorado)', error.message);
  }
  
  
  return; // ← Aseguramos que la promesa se resuelve
};

  const updateUser = (updatedData) => {
    if (user) {
      const updatedUser = { ...user, ...updatedData };
      setUser(updatedUser);
      localStorage.setItem('user', JSON.stringify(updatedUser));
       
    }
  };

  const value = {
    user,
    loading,
    error,
    updateUser,
    login,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};